// extracted by css-extract-rspack-plugin
export default {"columnsWrapper":"columns-wrapper--vfHIX_4l0z4R6uza","columnPhoto":"column-photo--RImr0DrjXaYMFoWG","columnContent":"column-content--q3SfppwQANVUv38P"};